import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spacer, ButtonDS, RowElement, TextCapitalized } from "@qivia/ui";
import { Page } from "../components/Page";
import { useAppSelector } from "../../redux/hooks";
import { selectCardExpenses } from "../qrCode/menuSlice";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import "../../i18n/i18n";

export const CategoryExpensesPage = () => {
  const { t } = useTranslation();
  const cardExpenses = useAppSelector(selectCardExpenses);

  if (!cardExpenses) {
    return;
  }

  return (
    <Page
      title={t("driverPayment.categoryExpenses.title")}
      backgroundColor="white"
      bottomButton={
        <StyledBottomButton>
          <ButtonDS
            text={t("stations.button.back")}
            buttonType="primary"
            format="hug"
            onClick={() => window.history.back()}
          />
        </StyledBottomButton>
      }
      withoutOverflowContent
    >
      <StyledColumn>
        <Spacer y={1} />
        {cardExpenses.categoryExpenses.map((expense) => {
          if (!expense.typeLimit) {
            return;
          }
          return (
            <div key={expense.category}>
              <StyledCategory>
                <TextCapitalized>
                  {t(`driverPayment.cardExpenses.type.${expense.category}`)}:
                </TextCapitalized>
              </StyledCategory>
              <Spacer y={0.5} />
              <RowElement
                text={
                  <StyledText>
                    {t(`driverPayment.cardExpenses.type.${expense.typeLimit}`)}
                  </StyledText>
                }
                size="M"
                bottomElement={
                  <StyledLine
                    $percentage={
                      expense.expenses
                        ? (expense.expenses / expense.amountLimit) * 100
                        : 0
                    }
                  />
                }
                rightElement={
                  <StyledExpenses>
                    {expense.expenses} /{expense.amountLimit}{" "}
                    {t(`driverPayment.cardExpenses.units`)}
                  </StyledExpenses>
                }
              />
              <Spacer y={1} />
            </div>
          );
        })}
        <Spacer y={1} />
      </StyledColumn>
    </Page>
  );
};

const StyledText = styled.div`
  white-space: nowrap;
`;

const StyledBottomButton = styled.div`
  width: 100%;
`;

const StyledCategory = styled.div`
  color: ${colors["colors/text/black"]};
  ${typographies["Body/L"]}
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const StyledLine = styled.div<{ $percentage: number }>`
  width: 100%;
  border-bottom: 0.25rem solid ${colors["colors/borders/button/primary"]};
  border-radius: 2rem;
  border-image: linear-gradient(
      to right,
      ${colors["colors/accent/500"]} ${({ $percentage }) => $percentage}%,
      ${colors["colors/borders/button/primary"]}
        ${({ $percentage }) => $percentage}%
    )
    5;
`;

const StyledExpenses = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 8rem;
`;
